import { render, staticRenderFns } from "./AccountReceivables.vue?vue&type=template&id=2408aa6e&scoped=true&"
import script from "./AccountReceivables.vue?vue&type=script&lang=ts&"
export * from "./AccountReceivables.vue?vue&type=script&lang=ts&"
import style0 from "./AccountReceivables.vue?vue&type=style&index=0&id=2408aa6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408aa6e",
  null
  
)

export default component.exports